import { Box } from "@mui/material"
import CircularProgress from "@mui/material/CircularProgress"
import Typography from "@mui/material/Typography"
import { styled } from "@mui/system"
import React from "react"

interface ScheduleMeetingDialogContainerProps {
  isLoading: boolean
  hasNoData?: boolean
  noDataText?: string
  children: React.ReactNode
}

const ScheduleMeetingDialogContainer = (props: ScheduleMeetingDialogContainerProps) => {
  const { isLoading, children, hasNoData, noDataText } = props

  if (isLoading) {
    return (
      <_Container>
        <CircularProgress variant="indeterminate" />
      </_Container>
    )
  }

  if (hasNoData) {
    return (
      <_ContainerNoData>
        <_NoDataText>{noDataText}</_NoDataText>
      </_ContainerNoData>
    )
  }

  return <>{children}</>
}

export default ScheduleMeetingDialogContainer

const _Container = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: 75,
  paddingBottom: 30,
}) as typeof Box

const _ContainerNoData = styled(_Container)({
  paddingTop: 30,
})

const _NoDataText = styled(Typography)({
  marginTop: 15,
  marginBottom: 30,
  paddingLeft: 20,
  paddingRight: 20,

  fontSize: 16,
  lineHeight: 1.125,
}) as typeof Typography
